export class DeleteGdsgObjectsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "keys",
            "baseName": "keys",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DeleteGdsgObjectsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
